import { createContext, FC, useState } from "react";
import { IBateriaVirtual } from "../../types/virtualBattery";
import { BatteryDistribution } from "../../types/percentages";

interface MoveVirtualBatteryContext {
  bateriaVirtualToMove?: IBateriaVirtual;
  newPercentage?: number;
  selectedBatteryDistribution?: BatteryDistribution;
  selectedBatteryId?: number;
  setBateriaVirtualToMove: (virBat: IBateriaVirtual) => void;
  setNewPercentage: (num: number) => void;
  setSelectedBatteryDistribution: (batDistribution: BatteryDistribution) => void;
  reset: () => void;
};

export const MoveVirtualBatteryContext = createContext<undefined | MoveVirtualBatteryContext>(undefined);

interface MoveVirtualBatteryContextProviderParams {
  children: JSX.Element;
}

const MoveVirtualBatteryContextProvider: FC<MoveVirtualBatteryContextProviderParams> = ({
  children 
}) => {
  const [bateriaVirtualToMove, setBateriaVirtualToMove] = useState<IBateriaVirtual>();
  const [newPercentage, setNewPercentage] = useState<number>();
  const [selectedBatteryId, setSelectedBatteryId] = useState<number>();
  const [selectedBatteryDistribution, setSelectedBatteryDistribution] = useState<BatteryDistribution>();

  const reset = () => {
    setBateriaVirtualToMove(undefined);
    setNewPercentage(undefined);
    setSelectedBatteryId(undefined);
    setSelectedBatteryDistribution(undefined);
  }

  const handleSetVirtualBatteryToMove = (bv: IBateriaVirtual) => {
    setBateriaVirtualToMove(bv);
    setSelectedBatteryDistribution(undefined);
    setSelectedBatteryId(undefined);
    setNewPercentage(undefined);
  }

  const handleSetSelectedBatteryDistribution = (newBatteryDistribution: BatteryDistribution) => {
    setSelectedBatteryDistribution(newBatteryDistribution);
    setSelectedBatteryId(newBatteryDistribution?.batteryId)
  }

  return (
    <MoveVirtualBatteryContext.Provider
      value={{
        newPercentage,
        setNewPercentage,
        selectedBatteryId,
        selectedBatteryDistribution,
        setSelectedBatteryDistribution: handleSetSelectedBatteryDistribution,
        bateriaVirtualToMove,
        setBateriaVirtualToMove: handleSetVirtualBatteryToMove,
        reset
      }}
    >
      {children}
    </MoveVirtualBatteryContext.Provider>
  );
};

export default MoveVirtualBatteryContextProvider;
